/*
 * @Author: glg 1344717517@qq.com
 * @Date: 2024-10-16 12:00:34
 * @LastEditors: glg 1344717517@qq.com
 * @LastEditTime: 2025-12-15 08:54:00
 * @FilePath: \hzfz\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE1
 */
import axios from "axios";
import router from '../router/index'
// let baseUrl = "http://192.168.2.113:8082"
// let baseUrl = "https://106.14.61.93" // 生产
// let baseUrl = "http://106.14.61.93:8082" // 生产
// let baseUrl = "https://www.sdfz.sh.cn/api" // 迁移地址
let baseUrl = "https://www.sdfz.sh.cn"

axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use((config) => {
    config.headers['token'] = sessionStorage.getItem('studentToken') || ''
    return config;
}),
    (error) => {
        return Promise.error(error);
    };


    /**
     * 接口错误在拦截器没有触发,需要捕获错误可以在请求数据通过catch捕获
     * **/
axios.interceptors.response.use((response) => {
    return response;
}),
    (error) => {
        return Promise.error(error);
    };
export default axios;



// WEBPACK FOOTER //
// ./src/utils/request.js